import { KeyboardBindType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useAppSelector from "@/core/helpers/useAppSelector";
import { keyCodeLabel } from "@/shared/constants/keyCodeLabel";
import { controlSettingsSelector } from "@/domains/settings/control/slice";

export default function useHintsValues() {
  const { t } = useTranslation("hud");
  const controlSettings = useAppSelector(controlSettingsSelector);
  const hintValues = useMemo(() => {
    if (isEmpty(controlSettings)) {
      return [];
    }

    return [
      {
        value: controlSettings[KeyboardBindType.MENU]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.MENU]?.key],
        label: t("hud.playerMenu"),
      },
      {
        value: controlSettings[KeyboardBindType.NAVIGATOR]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.NAVIGATOR]?.key],
        label: t("hud.navigator"),
      },
      {
        value: controlSettings[KeyboardBindType.VOICE_CHAT]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.VOICE_CHAT]?.key],
        label: t("hud.voiceChat"),
      },
      {
        value: controlSettings[KeyboardBindType.INVENTORY]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.INVENTORY]?.key],
        label: t("hud.inventory"),
      },
      {
        value: controlSettings[KeyboardBindType.INTERACT]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.INTERACT]?.key],
        label: t("hud.interaction"),
      },
      {
        value: controlSettings[KeyboardBindType.PHONE_OPEN_CLOSE]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.PHONE_OPEN_CLOSE]?.key],
        label: t("hud.phone"),
      },
      {
        value: controlSettings[KeyboardBindType.TABLET_OPEN_CLOSE]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.TABLET_OPEN_CLOSE]?.key],
        label: t("hud.tablet"),
      },
      {
        value: controlSettings[KeyboardBindType.ENGINE_TOGGLE]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.ENGINE_TOGGLE]?.key],
        label: t("hud.engine"),
      },
      {
        value: controlSettings[KeyboardBindType.TOGGLE_HINTS]?.key,
        char: keyCodeLabel[controlSettings[KeyboardBindType.TOGGLE_HINTS]?.key],
        label: t("hud.hideHints"),
      },
    ];
  }, [controlSettings, t]);

  return {
    hintValues,
  };
}
